import { SupportedLocales } from '../../../../utils/localization';

/**
 * Language type used in React-Select.
 */
export interface LanguageType {
	value: SupportedLocales;
	label: string;
}

/**
 * Supported languages in WAC.
 */
export const languages: LanguageType[] = [
	{
		label: 'Deutsch',
		value: 'de',
	},
	{
		label: 'English',
		value: 'en',
	},
	{
		label: 'Español',
		value: 'es',
	},
	{
		label: 'Français',
		value: 'fr',
	},
	{
		label: 'Italiano',
		value: 'it',
	},
	{
		label: '한국어',
		value: 'ko',
	},
	{
		label: 'Nederlands',
		value: 'nl',
	},
	{
		label: '日本語',
		value: 'ja',
	},
	{
		label: 'Polski',
		value: 'pl',
	},
	{
		label: 'Português',
		value: 'br',
	},
	{
		label: 'русский',
		value: 'ru',
	},
	{
		label: '中文',
		value: 'zh',
	},
];

/**
 * SVG for the language globe icon.
 * This is a copy of the icon from Magnolia, since the Brand globe icon only supports changing background color.
 */
export const LanguageGlobeIcon = ({ color }: { color: string }) => (
	<svg
		id="icon-wac-language-globe"
		aria-hidden="true"
		width="18px"
		height="18px"
		viewBox="0 0 25 24"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
	>
		<defs>
			<path
				d="M2.33514634,13.0909091 C2.80456741,17.1674997 5.87382928,20.4918664 9.91593939,21.5020963 C8.18760918,19.0069673 7.13798566,16.119686 6.87807529,13.0909091 L2.33514634,13.0909091 Z M2.33514634,10.9090909 L6.8751035,10.9090909 C7.12988231,7.89470494 8.18079774,5.00118821 9.91557751,2.49799419 C5.87364609,3.50833206 2.8045534,6.83262197 2.33514634,10.9090909 Z M22.6648537,10.9090909 C22.1954326,6.83250032 19.1261707,3.50813364 15.0840606,2.49790374 C16.8123908,4.99303266 17.8620143,7.88031403 18.1219247,10.9090909 L22.6648537,10.9090909 Z M22.6648537,13.0909091 L18.1248965,13.0909091 C17.8701177,16.1052951 16.8192023,18.9988118 15.0844225,21.5020058 C19.1263539,20.4916679 22.1954466,17.167378 22.6648537,13.0909091 Z M9.15315078,10.9090909 L15.843646,10.9090909 C15.5581939,7.94925479 14.3973512,5.12935736 12.4999751,2.78265622 C10.595448,5.13778492 9.43302782,7.96652031 9.15315078,10.9090909 Z M15.8468492,13.0909091 L9.15635402,13.0909091 C9.44180608,16.0507452 10.6026488,18.8706426 12.5000249,21.2173438 C14.404552,18.8622151 15.5669722,16.0334797 15.8468492,13.0909091 Z M12.5,24 C5.59644063,24 0,18.627417 0,12 C0,5.372583 5.59644063,0 12.5,0 C19.4035594,0 25,5.372583 25,12 C25,18.627417 19.4035594,24 12.5,24 Z"
				id="path-1"
			/>
		</defs>
		<g id="Final-Designs-" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
			<g id="WAC-Language-Banner-Drop-Down-Icon" transform="translate(-426.000000, -19.000000)">
				<g id="Alert-banner" transform="translate(-4.000000, 0.000000)">
					<g id="language-globe-icon" transform="translate(430.000000, 19.000000)">
						<mask id="mask-2" fill={'#ffffff'}>
							<use xlinkHref="#path-1" />
						</mask>
						<g id="language-globe-icon-color" mask="url(#mask-2)" fill={color}>
							<g transform="translate(-1.000000, -1.000000)" id="Rectangle">
								<rect x="0" y="0" width="27.2727273" height="26.4827586" />
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
);
